<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol
                    ><h1 class="page__title text-center">
                        {{ $t(titlePage) }}
                    </h1></CCol
                >
                <CCol>
                    <div class="btn-wrapper btn-wrapper__end-center">
                        <ButtonCreate
                            @click="
                                $router.push({
                                    name: 'create_segment',
                                })
                            "
                        >
                            {{ $t("Create segment") }}
                        </ButtonCreate>
                    </div>
                </CCol>
            </CRow>
            <!-- Title page -->
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.segments.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'segments',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="
                                            tables.segments.allFields
                                        "
                                        :activeFields.sync="
                                            tables.segments.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.segments.items"
                                    :fields="
                                        traslateLabels(
                                            tables.segments.fields
                                        )
                                    "
                                    :items-per-page="tables.segments.rows"
                                    :loading="tables.segments.loading"
                                    :columnFilterValue.sync="
                                        tables.segments.columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.segments.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    v-bind="tables.segments"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.segments
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'edit_segment',
                                                                params: {
                                                                    uuid: tables
                                                                        .segments
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("edit")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="dowload(tables.segments.itemSelected.uuid)"
                                                    >
                                                        <strong>{{
                                                            $t("download")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="count(tables.segments.itemSelected.uuid)"
                                                        :disabled="tables.segments.itemSelected && Boolean(tables.segments.itemSelected.counting)"
                                                    >
                                                        <strong>{{
                                                            $t("recalculate")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="clone(tables.segments.itemSelected)" 
                                                        :disabled="!tables.segments.itemSelected"
                                                    >
                                                        <strong>{{
                                                            $t("clone")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="archive(tables.segments.itemSelected.uuid)"
                                                    >
                                                        <strong>{{
                                                            $t("archive")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.segments
                                                        .itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'segments',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>

                                    <template #counting="{ item }">
                                        <td class="text-center">
                                            <CSpinner
                                                v-if="item.counting"
                                                grow
                                                color="success"
                                                size="sm"
                                            />
                                            <CSpinner v-else grow size="sm" />
                                        </td>
                                    </template>

                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/providers.api/groups"
                                                :table="tables.segments"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-show="tables.segments.items.length > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.segments.page"
                                        :pages="
                                            tables.segments.total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.segments.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'segments',
                    })
                "
            >
                <template #title> Create you first Provider </template>
                <template #description>
                    {{ $t("first_item.provider.description") }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        :title="$t('add_new_provider')"
                        @click="
                            $router.push({
                                name: 'add_provider',
                            })
                        "
                    >
                        {{ $t("create_provider") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'segments',
                            })
                        "
                        @click="
                            cleanFiltersAdvance('segments'), updateData()
                        "
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean Filter") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import NoItemsContainer from "~/components/NoItemsContainer";
/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import TableSettings from "£lement/TableSettings";
/** Icons */
import { eraser } from "~/assets/icons/js/eraser";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilTrash,
    cilGroup,
    cilArrowThickFromRight,
} from "@coreui/icons";

export default {
    name: "ProvidersMainPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonCreate,
        FilterFields,
        ButtonExport,
        NoItemsContainer,
        TableSettings,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilTrash,
        cilGroup,
        cilArrowThickFromRight,
        eraser,
    },
    watch: {
        "tables.segments.loading": {
            handler(newValue) {
                this.updatePageLoading(newValue);
            },
            deep: true,
        },
    },
    data() {
        return {
            tables: {
                segments: {
                    fields: [
                        {
                            key: "_selected",
                            label: "",
                            fixed: true,
                            sortable: false,
                            active: true,
                            filter: false,
                            _filter: false,
                            _style: "width:5%",
                        },
                        {
                            key: "id",
                            label: "#",
                            sorter: true,
                            filter: true,
                            _filter: true,
                            _style: "width:5%",
                            active: true,
                        },
                        {
                            key: "name",
                            label: "name",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "count",
                            label: "count",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "counting",
                            label: "counting",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "last_count_at",
                            label: "last_count_at",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                            sorter: true,
                        },
                        {
                            key: "created_at",
                            label: "creation_at",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                            sorter: true,
                        },
                        {
                            key: "updated_at",
                            label: "updated_at",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                            sorter: true,
                        },
                    ],
                    allFields: [],
                    items: [],
                    order: "desc",
                    rows: 10,
                    page: 1,
                    total_pages: 1,
                    loading: true,
                    hover: true,
                    pagination: true,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    sorterValue: {},
                    size: "sm",
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    matchResponse: "data.items",
                    matchResponsePages: "data.pages",
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                },
            },
        };
    },
    methods: {
        updatePagination(newValue) {
            this.tables.segments.page = newValue;
            this.updateData();
        },
        async updateData() {

            await this.updateTable({
                tableName: "segments",
                fetch: {
                    baseURL: process.env.VUE_APP_API_SASS,
                    // baseURL: "http://localhost:3000/prod",
                },
                url: `/segmentations/segments`,
                adapterFilters: (filters) => {
                    delete filters.where.created_at;
                    return filters;
                },
            });

            this.tables.segments.itemSelected = null;

            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },

        async dowload(uuid){
            this.updatePageLoading(true);
            this.provider = await this.fetcher({
                url: `/segmentations/segments/${uuid}/download`,
                method: "POST",
                baseURL: process.env.VUE_APP_API_SASS
            });
            this.showMessageSuccess();
            this.updatePageLoading(false);
        },

        async count(uuid){
            this.updatePageLoading(true);
            this.provider = await this.fetcher({
                url: `/segmentations/segments/${uuid}/count`,
                method: "PATCH",
                baseURL: process.env.VUE_APP_API_SASS
            });
            this.showMessageSuccess();

            await this.updateData();
            this.updatePageLoading(false);
        },
        async clone(item) {
            try {
                this.updatePageLoading(true);
                let response = await this.fetcher({
                    url: `/segmentations/segments/${item.uuid}`,
                    method: "GET",
                    baseURL: process.env.VUE_APP_API_SASS
                });

                let clone = {
                    name: null,
                    description: null,
                    query: null,
                };

                clone.name = response.data.name + " COPY";

                clone.description = response.data.description;
                clone.query = response.data.query;

                response = await this.fetcher({
                    url: `/segmentations/segments/`,
                    method: "POST",
                    data: clone,
                    baseURL: process.env.VUE_APP_API_SASS
                });
                this.showMessageByMethod("POST");
                this.updateData();
            } catch (error) {
                this.showMessageError(error);
            }finally{
                this.updatePageLoading(false);
            }
        },
        async archive(uuid){
            this.updatePageLoading(true);
            this.provider = await this.fetcher({
                url: `/segmentations/segments/${uuid}`,
                method: "PUT",
                baseURL: process.env.VUE_APP_API_SASS,
                data: {
                    archive: true
                }
            });
            this.showMessageSuccess();

            await this.updateData();
            this.updatePageLoading(false);
        }
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style lang="scss">
.btn-create-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>
